import React, { forwardRef, ReactElement } from 'react';
import { cx } from '@linaria/core';
import { styled } from '@linaria/react';
import { getLinariaClassName } from '../../../utils/getLinariaClassName';
import { Badge } from '../Badge';
import { Icon } from '../Icon';
import { Text } from '../Text';
export type PillVariant = (typeof PILL_VARIANTS)[number];
type Props = {
  /** Pass through classname to allow styles overrides */
  className?: string;
  /** Pass through style to allow styles overrides */
  style?: React.CSSProperties;
  /** Identify the element for selection in integration tests, FullStory, etc. */
  dataId?: string;
  /** Whether the pill is active or not */
  isSelected?: boolean;
  /** Pill content */
  children?: React.ReactNode;
  /** Action for pill click */
  onClick?: (e?: React.SyntheticEvent) => void;
  /** Icon left aligned */
  iconStart?: ReactElement;
  /** Icon right aligned */
  iconEnd?: ReactElement;
  /** Should show down arrow icon and border */
  showArrow?: boolean;
  /** Weather the button is disabled or not */
  isDisabled?: boolean;
  /** If a count should be displayed */
  count?: number;
  /** Pill variant */
  variant?: PillVariant;
  /** If should stretch to full width of parent */
  fullWidth?: boolean;
};
const PillElement = /*#__PURE__*/styled('button')({
  name: "PillElement",
  class: "pfy6bbb",
  propsAsIs: false
});
export const IconWrapper = /*#__PURE__*/styled('span')({
  name: "IconWrapper",
  class: "i1harj7p",
  propsAsIs: false
});
export const DownArrowIconWrapper = /*#__PURE__*/styled('span')({
  name: "DownArrowIconWrapper",
  class: "df2l0xb",
  propsAsIs: false
});
export const Pill = forwardRef<HTMLButtonElement, Props>(({
  children,
  isSelected = false,
  onClick,
  dataId,
  iconStart = null,
  iconEnd = null,
  showArrow = false,
  isDisabled = false,
  count = 0,
  variant = 'default',
  fullWidth = false,
  className,
  style
}, ref) => {
  const handleClick = (event: React.SyntheticEvent) => {
    event.preventDefault();
    if (onClick) onClick();
  };
  return <PillElement ref={ref} disabled={isDisabled} data-id={dataId} onClick={handleClick} className={cx(className, `${getLinariaClassName(PillElement)}--variant-${variant}`, isSelected && `--selected`, fullWidth && `--fullWidth`)} style={style}>
        {iconStart && <IconWrapper>{iconStart}</IconWrapper>}
        <Text variant="bodyS">{children}</Text>
        {iconEnd && <IconWrapper>{iconEnd}</IconWrapper>}
        {count > 0 && <Badge variant="info">{count}</Badge>}
        {showArrow && <DownArrowIconWrapper className={cx(`${getLinariaClassName(DownArrowIconWrapper)}--variant-${variant}`, isSelected && `--selected`)}>
            <Icon name="CaratDown" size="xs" />
          </DownArrowIconWrapper>}
      </PillElement>;
});
Pill.displayName = 'Pill';

require("./Pill.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./Pill.tsx");